import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NavbarComponent} from './navbar.component';
import {MaterialModule} from "../../../material.module";
import {MomentModule} from "angular2-moment";
import {LoadingModule} from "../../../autenticacion/loadingScreen/loading.module";
import {NgIdleModule} from "@ng-idle/core";
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";

@NgModule({
    imports: [RouterModule, CommonModule, MaterialModule, MomentModule,
        LoadingModule,
        NgIdleModule.forRoot(),
        NgIdleKeepaliveModule.forRoot()],
    declarations: [NavbarComponent],
    exports: [NavbarComponent]
})

export class NavbarModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/shared/navbar/navbar.module.ts